<template>
  <div>
    <a href="#langCurrCountrySwitchModal" ref='openModal' data-toggle="modal">
      <button style="color:white" class="btn btn-block" >
        {{ currentCurrencySymbol }} | {{ selectedLanguage.toUpperCase() }}
      </button>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted()
  {

  },
  computed: {
    selectedLanguage()
    {
      return App?.language ?? 'de';
    },
    currentCurrencySymbol()
    {
      return App?.activeCurrency ?? '€';
    },

  },
  methods: {

  }
};
</script>
